import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import './TestingReport.scss';
import { Grid, Paper, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { formatDate } from 'src/utils/utils';
import variables from 'src/style/variable/variables.module.scss';
import CancelIcon from '@mui/icons-material/CancelSharp';
import CheckCircleIcon from '@mui/icons-material/CheckCircleSharp';
import { useTranslation } from 'src/i18n';
export default function FinalizeAndSignOff ({
  onChange,
  data,
  readOnly,
  passed,
  showPassFail,
  showCommissioningStatus
} ) {
  const { t } = useTranslation();

  const user: any = useSelector((state: any) => state.authentication.get('user'));
  const onComment = (field, val) => {
    onChange(['signOff', field], val);
  };

  const hasStatusSection = showPassFail || showCommissioningStatus;

  return (
    <Paper className='finalize-container'>
      <Grid container>
        <Grid item xs={12} sm={hasStatusSection ? 4 : 8}><b>{t('testingReport.signOff.verifiedBy')}</b> {user.get('first_name', null)} {user.get('last_name', null)}</Grid>
        <Grid item xs={12} sm={4}><b>{t('testingReport.signOff.createdAt')}</b> {formatDate(new Date())}</Grid>
        {showPassFail  &&<Grid item xs={12} sm={4}>
          {
            passed ? <>
              <CheckCircleIcon style={{ color: variables.success, fontSize: 24, position: 'absolute' }} />
              <b style={{ marginLeft: '30px' }}>{t('common.passed')} </b></>
              :
              <>
                <CancelIcon style={{ color: variables.error, fontSize: 24, position: 'absolute' }} />
                <b style={{ marginLeft: '30px' }}>{t('common.failed')} </b>
              </>
          }


        </Grid>}

        {showCommissioningStatus && <Grid item xs={12} sm={4}>
          <ToggleButtonGroup
            value={data?.get('commissioningStatus') || ''}
            exclusive
            onChange={(_, val) => { if (val) onChange(['signOff', 'commissioningStatus'], val); }}
            disabled={readOnly}
            size="small"
          >
            <ToggleButton value="pass" className="commissioning-status-pass">
              {t('common.pass')}
            </ToggleButton>
            <ToggleButton value="pass-with-notes" className="commissioning-status-pass-with-notes">
              {t('common.passWithNotes')}
            </ToggleButton>
            <ToggleButton value="failed" className="commissioning-status-failed">
              {t('common.failed')}
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>}

        <Grid item xs={12}>
          <TextField
            multiline
            rows={8}
            fullWidth
            value={data?.get('recommendations')}
            disabled={readOnly}
            label={t('testingReport.signOff.recommendations')}
            onChange={(e) => { onComment('recommendations', e.target.value); }}
          />
        </Grid>

      </Grid>
    </Paper>

  );
}

FinalizeAndSignOff.propTypes = {
  onChange: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
  passed: PropTypes.bool,
  showPassFail: PropTypes.bool,
  showCommissioningStatus: PropTypes.bool,

};
FinalizeAndSignOff.defaultProps = {
  showPassFail: false,
  passed: false,
  showCommissioningStatus: false,

};
